<template>
  <div>
    <el-dialog
      title="选择经销商"
      :visible.sync="visible"
      class="wide-width-dialog"
    >
      <div class="view-filter">
        <el-input
          v-model="searchText"
          class="search-text"
          size="small"
          placeholder="请输入编码或名称"
        >
          <el-button slot="append" @click="onSearch">查找</el-button>
        </el-input>
      </div>
      <!--      多选-->
      <el-table
        height="320"
        v-if="isCheckbox"
        :data="gridData"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          property="client_code"
          label="经销商编码"
        ></el-table-column>
        <el-table-column property="name" label="经销商名称"></el-table-column>
        <el-table-column
          property="region_name"
          label="所在省份"
        ></el-table-column>
      </el-table>
      <!--      单选-->
      <el-radio-group
        v-model="selectionRadioVal"
        style="width:100%"
        v-if="!isCheckbox"
        @change="radioCurrentChange"
      >
        <el-table height="300" :data="gridData" class="radio-table">
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-radio :label="scope.row.client_code"></el-radio>
            </template>
          </el-table-column>
          <el-table-column
            property="plugin_code"
            label="插件编码"
            v-if="tableHead.indexOf(1) > -1"
          ></el-table-column>
          <el-table-column
            property="client_code"
            label="经销商编码"
          ></el-table-column>
          <el-table-column
            property="name"
            label="经销商名称"
            v-if="type != 5"
          ></el-table-column>
          <el-table-column
            property="client_name"
            label="经销商名称"
            v-if="type == 5"
          ></el-table-column>
          <el-table-column
            property="region_name"
            label="所在省份"
          ></el-table-column>
        </el-table>
      </el-radio-group>
      <div class="block" v-if="totalPage>1">
        <el-pagination
          background
          small
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="saveChange"
          :disabled="selectionVal.length === 0"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  clientGetClient,
  temporaryGetClientList,
  getBrokerList,
  getAllClient,
  chooseClient,
  getFtpClientList,
  get_new_broker_list
} from "@/api/index";

export default {
  name: "ChooseDealer",
  props: {
    isCheckbox: {
      type: Boolean,
      default: true
    },
    isClearSearchText: {
      type: Boolean,
      default: false
    },
    // 1-所有终端 2-已经绑定终端 3-网站抓取文件拆分选择经销商（网站映射管理已选择经销商）4-所有经销商 5-邮件抓取选择经销商
    type: {
      type: Number,
      default: 1
    },
    // 1-插件编码
    tableHead: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: () => ({
    visible: false,
    selectionVal: [],
    selectionRadioVal: "",
    searchText: "",
    gridData: [],
    currentPage: 1,
    totalCount: 0,
    totalPage: 0,
    _index: ""
  }),
  methods: {
    _getList(page) {
      let scrap_type =
        this.$route.params.scrap_type == 3 ? 2 : this.$route.params.scrap_type;
      if (this.type === 1) {
        clientGetClient(page, this.searchText, scrap_type).then(res => {
          this.visible = true;
          if (0 === res.status) {
            this.gridData = res.data.clientPage;
            this.totalCount = res.data.totalCount;
            this.currentPage = parseInt(res.data.currentPage);
            this.totalPage = res.data.totalPage;
          } else {
            this.gridData = [];
            this.totalCount = 0;
            this.currentPage = 1;
            this.totalPage = 0;
          }
        });
      } else if (this.type === 2) {
        temporaryGetClientList(page, this.searchText, scrap_type).then(res => {
          if (0 === res.status) {
            let gridData = res.data.clientPage;
            for (let item of gridData) {
              item.name = item.client_name;
            }
            this.gridData = gridData;
            this.totalCount = res.data.totalCount;
            this.currentPage = parseInt(res.data.currentPage);
            this.totalPage = res.data.totalPage;
          } else {
            this.gridData = [];
            this.totalCount = 0;
            this.currentPage = 1;
            this.totalPage = 0;
          }
        });
      } else if (this.type === 3) {
        let fn = getBrokerList;
        if (this._index == 1) {
          fn = get_new_broker_list;
        }
        fn(page, this.searchText, scrap_type).then(res => {
          if (0 === res.status) {
            let gridData = res.data.clientPage;
            this.gridData = gridData;
            this.totalCount = res.data.totalCount;
            this.currentPage = parseInt(res.data.currentPage);
            this.totalPage = res.data.totalPage;
          } else {
            this.gridData = [];
            this.totalCount = 0;
            this.currentPage = 1;
            this.totalPage = 0;
          }
        });
      } else if (this.type === 4) {
        getAllClient(page, this.searchText, scrap_type).then(res => {
          this.visible = true;
          if (0 === res.status) {
            this.gridData = res.data.clientPage;
            this.totalCount = res.data.totalCount;
            this.currentPage = parseInt(res.data.currentPage);
            this.totalPage = res.data.totalPage;
          } else {
            this.gridData = [];
            this.totalCount = 0;
            this.currentPage = 1;
            this.totalPage = 0;
          }
        });
      } else if (this.type === 5) {
        chooseClient(page, this.searchText, scrap_type).then(res => {
          this.visible = true;
          if (0 === res.status) {
            this.gridData = res.data.list;
            this.totalCount = res.data.totalCount;
            this.currentPage = parseInt(res.data.currentPage);
            this.totalPage = res.data.totalPage;
          } else {
            this.gridData = [];
            this.totalCount = 0;
            this.currentPage = 1;
            this.totalPage = 0;
          }
        });
      } else if (this.type === 6) {
        //ftp
        getFtpClientList(page, this.searchText, scrap_type).then(res => {
          if (0 === res.status) {
            let gridData = res.data.list;
            this.gridData = gridData;
            this.totalCount = res.data.totalCount;
            this.currentPage = parseInt(res.data.currentPage);
            this.totalPage = res.data.totalPage;
          } else {
            this.gridData = [];
            this.totalCount = 0;
            this.currentPage = 1;
            this.totalPage = 0;
          }
        });
      }
    },
    handleCurrentChange(currentPage) {
      this._getList(currentPage);
    },
    openDialog(e, _index) {
      /*
       * type: 1(网站文件拆分管理>新流程新增)
       * */
      this._index = _index;
      if (this.isClearSearchText) {
        this.searchText = "";
      }
      if (!this.isCheckbox) {
        if (e && e.length > 0) {
          this.selectionRadioVal = e[0].client_code;
        } else {
          this.selectionRadioVal = "";
        }
        this.visible = true;
      }

      this._getList(1);
    },
    selectionChange(val) {
      this.selectionVal = val;
    },
    radioCurrentChange(val) {
      if (val) {
        this.selectionRadioVal = val;
        const target = this.gridData.filter(item => item.client_code === val);
        if (target) {
          this.selectionVal = [target[0]];
        }
      }
    },
    saveChange() {
      this.$emit("saveChange", this.selectionVal);
      this.visible = false;
    },
    onSearch() {
      this._getList(1);
    }
  }
};
</script>

<style scoped lang="scss">
.view-filter {
  margin-bottom: 10px;
}

.search-text {
  margin-right: 10px;
  width: 300px;
}
</style>
